import {
  CATEGORIES_SET,
  NODE_SET,
  NODE_SYNC_FINISHED,
  NODE_SYNC_INITIATED,
  PATHS_SET,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
} from './actionTypes';
import {
  ICategoriesAction,
  ICategoriesState,
  IFailedSyncAction,
  INodeAction,
  INodeSyncAction,
  ISetCategoriesAction,
} from './types';

export const initialState = {
  categories: [],
  error: null,
  nodes: {},
  paths: {},
  syncing: 0,
  syncingNodes: {},
};

export const reducer = (
  state: ICategoriesState = initialState,
  action: ICategoriesAction
): ICategoriesState => {
  switch (action.type) {
    case CATEGORIES_SET:
      return {
        ...state,
        categories: (action as ISetCategoriesAction).payload,
      };
    case NODE_SET:
      return {
        ...state,
        nodes: {
          ...state.nodes,
          [(action as INodeAction).payload.id]: (action as INodeAction).payload.children,
        },
      };
    case NODE_SYNC_FINISHED:
      return {
        ...state,
        syncingNodes: { ...state.syncingNodes, [(action as INodeSyncAction).payload]: false },
      };
    case NODE_SYNC_INITIATED:
      return {
        ...state,
        syncingNodes: { ...state.syncingNodes, [(action as INodeSyncAction).payload]: true },
      };
    case PATHS_SET:
      return {
        ...state,
        paths: {
          ...state.paths,
          ...(action as INodeAction).payload,
        },
      };
    case SYNC_FINISHED:
      return { ...state, syncing: state.syncing - 1 };
    case SYNC_INITIATED:
      return { ...state, error: null, syncing: state.syncing + 1 };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload };
    default:
      return state;
  }
};
